// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import { UIKind } from "../../../define/UIKind";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ExamSuccessLayer extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	spr_success2: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	spr_success: cc.Node = null;

   
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {

        let gameManager = NormalGameManager._instance;
        let gameData = gameManager.getGameData();
        let officialLv = gameData.m_officialLv;
        if (officialLv > 2) {
            this.spr_success2.active = true;
            this.spr_success.active = false;
        } else {
            this.spr_success2.active = false;
            this.spr_success.active = true;
        }

        this.addLayerTouchEvent();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.EXAM_SUCCESS_LAYER);
        O1HD.emit("normalMode.onBackNormal", UIKind.UILayerTag.EXAM_LAYER);
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.EXAM_SUCCESS_LAYER);
    }

    // update (dt) {}
}
